import { BoardMedicalCase } from './board-medical-case.model';
export class CaseMedicalFilterResponse {
  totalNumber: number;
  boardMedicalCaseDtoList: BoardMedicalCase[];

  public constructor(init?: Partial<CaseMedicalFilterResponse>) {
    Object.assign(this, init);
  }
}
